<template>
  <v-container>
    <v-container class="mt-4">
      <v-row>
        <excel-import></excel-import>
        <v-col cols="12">
          <v-expansion-panels class="ma-0">
            <v-expansion-panel>
              <v-expansion-panel-header color="primary" dark class="white--text ma-0">
                <template v-slot:actions>
                  <v-icon class="icon white--text">$expand</v-icon>
                </template>
                <span>
                  <v-icon class="mr-2 white--text">mdi-briefcase</v-icon>
                  <span>Manage Units</span>
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col md="3" sm="12" v-if="authPermissions.has('stock_units:create')">
                    <v-toolbar color="primary" dark>
                      Add Unit
                    </v-toolbar>
                    <create-unit />
                  </v-col>
                  <v-col md="9" sm="12" v-if="authPermissions.has('stock_units:view')">
                    <v-toolbar color="primary" dark>Unit Index</v-toolbar>
                    <index-unit @editUnit="initEditUnit" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col md="4" sm="12" v-if="authPermissions.has('stocks:create')">
          <v-card class="ma-0" style="-webkit-app-region: no-drag">
            <v-toolbar color="primary" dark>
              <v-card-title class="justify-start">
                ADD Stock
              </v-card-title>
            </v-toolbar>
            <create-Stock @close-dialog="createStock = false" />
          </v-card>
        </v-col>
        <v-col md="8" sm="12" v-if="authPermissions.has('stocks:view')">
          <v-card class="ma-0" elevation="2">
            <v-toolbar color="primary" dark>
              <v-card-title>Stock Index</v-card-title>
            </v-toolbar>
            <index-Stock @editStock="initEditStock"></index-Stock>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- dialog -->
    <v-dialog dismissable max-width="600px" v-model="editStock" eager>
      <v-card style="-webkit-app-region: no-drag">
        <v-card-title>Edit Stock</v-card-title>
        <edit-Stock ref="edit-stock" @close-dialog="editStock = false"></edit-Stock>
      </v-card>
    </v-dialog>
    <v-dialog dismissable max-width="600px" v-model="editUnit" eager>
      <v-card style="-webkit-app-region: no-drag">
        <v-card-title>Edit Stock</v-card-title>
        <edit-unit :propUnitId="propUnitData.id" :propUnitData="propUnitData"
          @close-dialog="editUnit = false"></edit-unit>
      </v-card>
    </v-dialog>
    <!-- <v-dialog
      v-model="createStock"
      max-width="600px"
      style="-webkit-app-region: no-drag"
    > -->
    <!-- </v-dialog> -->
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'vStocks',
  components: {
    createStock: () => import('./../components/stock/Create'),
    indexStock: () => import('./../components/stock/Index'),
    editStock: () => import('./../components/stock/Edit'),
    createUnit: () => import('./../components/unit/Create'),
    indexUnit: () => import('./../components/unit/Index'),
    editUnit: () => import('./../components/unit/Edit'),
    excelImport: () => import('@/views/dashboard/components/stock/Import'),
  },
  mounted() {
    this.fetchAllUnits()
  },
  data() {
    return {
      // createStock: false,
      editStock: false,
      editUnit: false,
      propUnitData: {
        unit: null,
        description: null,
      },
      // propStockData: {
      //   name: null,
      //   address: null,
      //   subscriptionDate: null,
      //   contactNo1: null,
      //   contactNo2: null,
      // },
    }
  },
  computed: {
    ...mapState({
      unitUpdated: state => state.unit.channelUpdate,
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  watch: {
    unitUpdated() {
      this.fetchAllUnits()
    },
  },
  methods: {
    ...mapActions({
      fetchAllUnits: 'unit/fetchAll',
    }),
    initEditUnit(unitData) {
      this.editUnit = true
      this.propUnitData = unitData
    },
    initEditStock(stockData) {
      const { populateInput } = this.$refs['edit-stock']
      this.editStock = true
      populateInput(stockData)
    },
  },
}
</script>
